//
// Module for the Notifications Index view
//
rs.module("content/user/notifications/index",

    [],

    function () {

        //
        // Initialize the module
        //
        function initialize(lrsGridApi, jsSelectors, readCodeValue, gridNameValueMarker) {
            $(document).onjs("click", jsSelectors.viewLink, function () {
                // This only sets the status visually. Viewing the notification in DocumentController's View action makes the backend call to actually set it.
                var id = $(this).closest("div[role='row']")[0].attributes["row-id"].value;
                var rowNode = lrsGridApi.agGridApi.getRowNode(id);
                rowNode.setSelected(false);
                rowNode.setDataValue('AlertDetailStatus', [readCodeValue.Key, readCodeValue.Name, gridNameValueMarker]);
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);  